import { useState } from 'react';
import cvData from '../data/cv-data.json';

// Define types matching the structure in pdf-parser.ts
export interface Experience {
  title: string;
  company: string;
  period: string;
  description: string[];
}

export interface Skill {
  name: string;
  level?: number;
  at?: string[];
}

export interface SkillCategory {
  id: string;
  name: string;
  skills: Skill[];
}

export interface Education {
  school: string;
  major: string;
  period: string;
}

export interface Certificate {
  name: string;
  issuer: string;
  date: string;
  url?: string;
}

export interface Project {
  title: string;
  description: string;
  technologies: string[];
  github?: string;
  demo?: string;
}

export interface CVData {
  name: string;
  title: string;
  summary: string;
  location?: string;
  highlight?: string;
  education: Education[];
  certificates: Certificate[];
  experiences: Experience[];
  skillCategories: SkillCategory[];
  projects: Project[];
  contact: {
    email: string;
    linkedin?: string;
    github?: string;
    phone?: string;
    website?: string;
    resume?: string;
  };
}

export function useCV() {
  const [data] = useState<CVData>(cvData as CVData);
  
  return {
    data,
    experiences: data.experiences,
    education: data.education,
    certificates: data.certificates,
    location: data.location,
    highlight: data.highlight,
    skillCategories: data.skillCategories,
    projects: data.projects,
    contact: data.contact,
    summary: data.summary,
    name: data.name,
    title: data.title
  };
} 